import React, {FunctionComponent, useState} from 'react';
import classnames from 'classnames';
import {Menu, Dropdown, Row, Col,Badge} from 'antd';
import {Icon} from '@/components';
import StylesType from '@/types/StylesType';
import {roomTypes} from '@/types/APITypes';
import {useEffectOnce} from 'react-use'
import './style';

export interface NavPropsType extends StylesType {
    onChange: (e: EventType) => void;
    userName?: string;
    dataSource: roomTypes [];
    activeData: roomTypes;
}

export interface EventType {
    key: React.SetStateAction<string>;
    type: 'room'|'user' | 'menu';
}


export const SiteSwitching: FunctionComponent<NavPropsType> = props => {

    const {prefixCls, onChange, dataSource, activeData} = props;


    const [current, setCurrent] = useState('1');

    const handleClick = (e: {key: React.SetStateAction<string>}) => {
        setCurrent(e.key)
        onChange({key: e.key, type: 'room'})
    };

    const menu = (
        <Menu onClick={handleClick} selectedKeys={[current]} className={`${prefixCls}-site-switching-menu-list`}>
            {dataSource.map(item =>  <Menu.Item key={item.id}>
                <Badge status={item.roomStatus === 1 ? 'success' : 'error'} text={item.roomName} />
            </Menu.Item>)}
        </Menu>
    );

    if (!activeData) return <></>

    return (
        <Dropdown overlayClassName={`${prefixCls}-site-switching`} overlay={menu}>
            <span className={`${prefixCls}-site-switching-text`}>站点：{activeData.roomName}</span>
        </Dropdown>
    )

}

export const Logo: FunctionComponent<NavPropsType> = props => {

    const {prefixCls} = props;

    return (
        <div className={`${prefixCls}-logo`}>
          <img style={{width: '70%',height:'70%'}} src={require('@/assets/logo.png')} alt=""/>
        </div>
    )
}

export const UserCenter: FunctionComponent<NavPropsType> = props => {

    const {prefixCls, userName, onChange} = props;

    const [current, setCurrent] = useState('1')

    const handleClick = (e: {key: React.SetStateAction<string>}) => {
        setCurrent(e.key)
        onChange({key: e.key, type: 'user'})
    };

    const menu = (
        <Menu onClick={handleClick} selectedKeys={[current]} className={`${prefixCls}-usercenter-menu-list`}>
            <Menu.Item key="1">修改密码</Menu.Item>
            <Menu.Item key="2">增值订单</Menu.Item>
            <Menu.Item key="3">设备订单</Menu.Item>
            <Menu.Item key="4">退出系统</Menu.Item>
        </Menu>
    );

    return (
        <Row className={`${prefixCls}-usercenter`} type='flex' align='middle'>
            {/*<Col className={`${prefixCls}-usercenter-help`}>*/}
            {/*    <span><Icon type='iconbangzhu' className={`${prefixCls}-usercenter-help-icon`}></Icon> 帮助</span>*/}
            {/*</Col>*/}
            <Col>
        您好，
                <Dropdown overlayClassName={`${prefixCls}-usercenter-menu`} overlay={menu}>
                    <span>
                        {userName}
                        <Icon className={`${prefixCls}-usercenter-icon`} type='iconxialajiantou'></Icon>
                    </span>
                </Dropdown>
            </Col>
        </Row>
    )

}

export const Menulist: FunctionComponent<NavPropsType> = props => {

    const {prefixCls, onChange} = props;

    const [current, setCurrent] = useState('1')

    const handleClick = (e: {key: React.SetStateAction<string>}) => {
        setCurrent(e.key)
        onChange({key: e.key, type: 'menu'})
    };
    
    useEffectOnce(() => {
      const pathName = window.location.pathname;
      if (pathName.indexOf('Home/Vas') !== -1) {
        setCurrent('3')
      }
      if (pathName.indexOf('Home/Buy') !== -1) {
        setCurrent('2')
      }
  
      if (pathName.indexOf('Home/CloudPhone') !== -1) {
        setCurrent('1')
      }
    })

    return (
    <>
      <Menu className={`${prefixCls}-menulist`} onClick={handleClick} selectedKeys={[current]} mode="horizontal">
          <Menu.Item
              className={classnames(`${prefixCls}-menulist-item`, {[`${prefixCls}-menulist-active`]: current === '1'})}
              key={1}>
          我的云机
          </Menu.Item>
          <Menu.Item
              className={classnames(`${prefixCls}-menulist-item`, {[`${prefixCls}-menulist-active`]: current === '2'})}
              key={2}>
          购买云机
          </Menu.Item>
          <Menu.Item
              className={classnames(`${prefixCls}-menulist-item`, {[`${prefixCls}-menulist-active`]: current === '3'})}
              key={3}>
          配套服务
          </Menu.Item>
      </Menu>
    </>
    )

}

export const Nav: FunctionComponent<NavPropsType> = props => {

    const {prefixCls, className, style} = props;

    return (
        <Row  style={style} className={classnames(prefixCls, className)} type='flex' align='middle' justify='space-between'>
            <Col><Logo {...props}/></Col>
            <Col><SiteSwitching {...props} /></Col>
            <Col span={12}><Menulist {...props}/></Col>
            <Col><UserCenter {...props}/></Col>
        </Row>
    )

}

Nav.defaultProps = {
    prefixCls: 'gc-nav',
}

export default Nav;
